<bz-cities-search
  [searchCitiesHints]="searchCitiesHints | async"
  [cityControl]="cityControl"
  [currentLang]="currentLang"
  [addExtraPadding]="false"
  (onChangeCity)="onChangeCity($event)"
></bz-cities-search>